/**
 * IM挂件
 */
import React from 'react'
import { MessageOutlined } from '@/components/AntdIcon'
import { useTranslation } from '@/libs/next-lang'
import styles from './index.module.less'

const IMBadge = () => {
  const { t } = useTranslation(['components'])
  return (
    <div className={styles['im-badge']}>
      <div className="content" onClick={() => window.IMInstance?.jumpCoopWebFn?.()}>
        <MessageOutlined className="icon" />
        <div className="txt">{t('components:t126')}</div>
      </div>
    </div>
  )
}
export default IMBadge
